// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, collection, addDoc, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCRv5MkWMc12xbSt18AmcaMo8dM_oi1O-8",
  authDomain: "eagle-learning.firebaseapp.com",
  projectId: "eagle-learning",
  storageBucket: "eagle-learning.firebasestorage.app",
  messagingSenderId: "96996979366",
  appId: "1:96996979366:web:d9c8e7fb3cf96593c9ba67"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();

export { db, collection, addDoc, getDocs, auth, storage, provider };

